import { useIonToast } from "@ionic/react";
import { useTranslation } from "react-i18next";

export const useAnnotationFormCreationToaster = () => {
  const { t } = useTranslation();

  const [showToast] = useIonToast();

  const showSuccessAnnotationFormToast = (message: string) =>
    showToast({
      message,
      duration: 3_000,
      color: "success",
      position: "top",
    });

  const showFailAnnotationFormToast = (message: string) =>
    showToast({
      message,
      duration: 3_000,
      color: "danger",
      position: "top",
    });

  const showCreationSuccess = () => showSuccessAnnotationFormToast(t("plan.annotationForm.success"));

  const showTooLargeFail = () => showFailAnnotationFormToast(t("plan.annotationForm.imageTooLarge"));
  const showAnyErrorFail = () => showFailAnnotationFormToast(t("plan.annotationForm.unknownError"));

  return {
    showCreationSuccess,
    showTooLargeFail,
    showAnyErrorFail,
  };
};
